<div class="setup-dialog" [dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
    <!-- Dialog Header -->
    <div class="dialog-header">
        <div class="header-icon">
            <mat-icon>business_center</mat-icon>
        </div>
        <h2 mat-dialog-title>{{ 'SETUP_DIALOG.TITLE' | translate }}</h2>
        <p class="header-subtitle">{{ 'SETUP_DIALOG.SUBTITLE' | translate }}</p>
    </div>

    <mat-dialog-content>
        <!-- Step 1: Service Type -->
        <div class="setup-section">
            <div class="section-header">
                <div class="step-badge">1</div>
                <h3>{{ 'SETUP_DIALOG.SERVICE_TYPE' | translate }}</h3>
                <span class="required-badge">{{ 'SETUP_DIALOG.REQUIRED' | translate }}</span>
            </div>
            <p class="section-desc">{{ 'SETUP_DIALOG.SELECT_SERVICE_TYPE_DESC' | translate }}</p>
            <div class="selection-grid">
                @for (type of serviceType; track type.id) {
                <div class="selection-card" [class.selected]="selectedType(type.id)"
                    (click)="selectSpecificType(type.id)">
                    <span class="card-label">{{ type.name }}</span>
                    @if (selectedType(type.id)) {
                    <mat-icon class="check-icon">check_circle</mat-icon>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Step 2: Services -->
        @if (filteredServices.length > 0) {
        <div class="setup-section">
            <div class="section-header">
                <div class="step-badge">2</div>
                <h3>{{ 'SETUP_DIALOG.SERVICES' | translate }}</h3>
                <span class="required-badge">{{ 'SETUP_DIALOG.REQUIRED' | translate }}</span>
            </div>
            <p class="section-desc">{{ 'SETUP_DIALOG.SELECT_SERVICE_DESC' | translate }}</p>
            <div class="selection-grid">
                @for (service of filteredServices; track service.id) {
                <div class="selection-card" [class.selected]="selectedService(service.id)"
                    (click)="selectSpecificService(service.id)">
                    <span class="card-label">{{ service.name }}</span>
                    @if (selectedService(service.id)) {
                    <mat-icon class="check-icon">check_circle</mat-icon>
                    }
                </div>
                }
            </div>
        </div>
        }

        <!-- Step 3: Categories -->
        @if (filteredServicesCategories.length > 0) {
        <div class="setup-section">
            <div class="section-header">
                <div class="step-badge">3</div>
                <h3>{{ 'SETUP_DIALOG.SERVICE_CATEGORIES' | translate }}</h3>
                <span class="required-badge">{{ 'SETUP_DIALOG.REQUIRED' | translate }}</span>
                <div class="category-actions">
                    <button mat-button color="primary" (click)="selectAllCategories()" type="button">
                        {{ 'SETUP_DIALOG.SELECT_ALL' | translate }}
                    </button>
                    <button mat-button color="warn" (click)="clearAllCategories()" type="button">
                        {{ 'SETUP_DIALOG.CLEAR_ALL' | translate }}
                    </button>
                </div>
            </div>
            <p class="section-desc">{{ 'SETUP_DIALOG.SELECT_CATEGORIES_DESC' | translate }}</p>
            <div class="categories-grid">
                @for (category of filteredServicesCategories; track category.id) {
                <mat-checkbox [checked]="isCategorySelected(category)" (change)="onCategoryChange(category, $event)"
                    color="primary">
                    {{ category.name }}
                </mat-checkbox>
                }
            </div>
        </div>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-flat-button color="primary" (click)="save()" [disabled]="!isValid || isSaving">
            <mat-icon>save</mat-icon>
            {{ 'SETUP_DIALOG.SAVE' | translate }}
        </button>
    </mat-dialog-actions>
</div>